(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2274],{

/***/ 59944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_landing_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94964);
/* harmony import */ var _components_landing_Head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81519);
/* harmony import */ var _components_landing_Press__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71723);
/* harmony import */ var _data_press_items_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48379);
/* harmony import */ var _data_seo_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35546);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);








var PRESS_DATA = _data_press_items_json__WEBPACK_IMPORTED_MODULE_4__.find(function (i) {
  return i.name === "datamynt-alibaba";
});

function DataMyntSolana() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Head__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      SEO: _data_seo_json__WEBPACK_IMPORTED_MODULE_5__
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_components_landing_Press__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        item: PRESS_DATA,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "font-semibold text-lg",
          children: "The partnership includes three parts: first, enabling Alibaba Cloud customers to pay for their Cloud services using Data Mynt\u2019s crypto as currency option; second, listing and selling Data Mynt services to Cloud customers on Alibaba Cloud International Marketplace; and third, bringing advanced, secure and reliable cloud and web3.0 services and technologies to businesses in Africa, Latin America and beyond."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "San Francisco, CA (November 9, 2022) - With over 200,000,000 consumers and businesses buying and owning cryptocurrency for purchasing power in emerging markets where multiple exchange rates and capital controls plague businesses; card decline rates top 70%; cross border payment settlement times reach 7 days, Data Mynt unlocks the efficiency and security of multi-currency blockchain payments for Alibaba Cloud and its customers."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Through its on the ground team and local presence, Data Mynt today supports on and offline businesses across Nigeria, Kenya, Ghana, South Africa, Mexico, and the Philippines."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex items-center space-x-8",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
              width: "93",
              height: "68",
              viewBox: "0 0 93 68",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                opacity: "0.3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M35.4316 0L39.7465 8.855C28.3005 13.363 24.6063 22.9233 24.19 27.14C32.29 28.6733 46.923 36.041 40.655 53.245C34.3869 70.449 17.9824 68.0033 10.5637 64.63C5.3782 62.3683 -3.67566 52.624 1.59314 31.74C6.86194 10.856 26.3474 1.87833 35.4316 0Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M86.2577 0L90.5727 8.855C79.1267 13.363 75.4325 22.9233 75.0161 27.14C83.1161 28.6733 97.7492 36.041 91.4811 53.245C85.2131 70.449 68.8086 68.0033 61.3899 64.63C56.2044 62.3683 47.1505 52.624 52.4193 31.74C57.6881 10.856 77.1736 1.87833 86.2577 0Z",
                  fill: "#3D8ECD"
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-gray-50",
            children: "\u201CWith the massive adoption we\u2019re seeing in African and Latin American markets, this partnership supports both Data Mynt and Alibaba Cloud\u2019s emerging markets strategies while solving major pain points for Alibaba Cloud\u2019s customer base today.\u201D said Alex Christian, CEO of Data Mynt."
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex items-center space-x-8",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
              width: "93",
              height: "68",
              viewBox: "0 0 93 68",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                opacity: "0.3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M35.4316 0L39.7465 8.855C28.3005 13.363 24.6063 22.9233 24.19 27.14C32.29 28.6733 46.923 36.041 40.655 53.245C34.3869 70.449 17.9824 68.0033 10.5637 64.63C5.3782 62.3683 -3.67566 52.624 1.59314 31.74C6.86194 10.856 26.3474 1.87833 35.4316 0Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M86.2577 0L90.5727 8.855C79.1267 13.363 75.4325 22.9233 75.0161 27.14C83.1161 28.6733 97.7492 36.041 91.4811 53.245C85.2131 70.449 68.8086 68.0033 61.3899 64.63C56.2044 62.3683 47.1505 52.624 52.4193 31.74C57.6881 10.856 77.1736 1.87833 86.2577 0Z",
                  fill: "#3D8ECD"
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-gray-50",
            children: "According to Selina Yuan, Alibaba Cloud Intelligence International President, \u201CPartners have always been a key focus for Alibaba Cloud, and we are committed to providing them with strong support for our ongoing co-creation and value-add - both technologically and commercially - to further empower our customers.\u201D"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("p", {
          className: "text-gray-50",
          children: ["Interested merchants and businesses can add Data Mynt digital asset checkout now at", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "https://play.google.com/store/apps/details?id=com.datamynt",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary underline",
              children: "Google Play Store"
            })
          }), " ", "and", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "https://apps.apple.com/us/app/datamynt-point-of-sale-pos/id1572840222",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary underline",
              children: "App Store"
            })
          }), "."]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h6", {
          className: "text-black text-md",
          children: "About DataMynt"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "With Data Mynt, you can run your business from your pocket using secure, compliant crypto as currency payments and financial operations infrastructure. Its suite of business tracking, notifications, wallet, fiat on off ramps, customer engagement, and payment solutions offers businesses of all sizes an easy approach to growing your business free from traditional cryptocurrency volatility and the usual risks and costs of traditional payment methods such as cards. Learn more:"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("ul", {
          className: "flex space-x-4",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://datamynt.com",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Website"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://twitter.com/DataMynt",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Twitter"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://www.linkedin.com/company/datamynt/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "LinkedIn"
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h6", {
          className: "text-black text-md",
          children: "About Alibaba Cloud"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Established in 2009, Alibaba Cloud (www.alibabacloud.com) is the digital technology and intelligence backbone of Alibaba Group. It offers a complete suite of cloud services to customers worldwide, including elastic computing, database, storage, network virtualization services, large-scale computing, security, management and application services, big data analytics, a machine learning platform and IoT services. Alibaba maintained its position as the third leading public cloud IaaS service provider globally since 2018, according to IDC. Alibaba is the world\u2019s third leading and Asia Pacific\u2019s leading IaaS provider by revenue in U.S. dollars since 2018, according to Gartner. With its international operations headquartered in Singapore, Alibaba Cloud had over $9.2b in revenue in 2020 and over 4 million paying customers including Ford Motor Co, IBM\u2019s Red Hat, and Hewlett Packard Enterprise across 200 countries, including services and data centers in the United States."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
          className: "flex space-x-4",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://www.alibabacloud.com/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Website"
              })
            })
          })
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (DataMyntSolana);

/***/ }),

/***/ 39951:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/datamynt-alibaba",
      function () {
        return __webpack_require__(59944);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,7258,5675,2580,6770,646,9530,2834,7965,4964,169,6111,9774,2888,179], function() { return __webpack_exec__(39951); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);